export * from './Voice.container'



// WEBPACK FOOTER //
// src/pages/Voice/index.ts